// extracted by mini-css-extract-plugin
module.exports = {"popoverClass":"PeriodFilterBlock_popoverClass__9O931","selects":"PeriodFilterBlock_selects__3Zj4M"};